import random from 'lodash/random';

/**
 * A helper that returns a random seller id
 * @returns a random id
 */
export const getSellerId = () => `${new Date().getTime().toString()}-${random(0, 1000).toString()}`;

/**
 * A helper that splits the comma separated reserve (system) bidder approval ids from the connect response
 * @param adminBidderApprovalIds comma separated approval ids, absent when the sale has no reserve bidders
 * @returns list of approval ids
 */
export const getAdminBidderApprovalIds = (adminBidderApprovalIds?: string): string[] =>
  (adminBidderApprovalIds || '')
    .split(',')
    .map(approvalId => approvalId.trim())
    .filter(Boolean);
